import React from 'react';
import {
  RootDiv,
  GiftAmountTypography,
  ValidityTypography,
  TextContainer,
  IconContainer,
  LoyaltyDiscountTagStyled,
} from './referralBannerDiscount.styles';
import { capitalizeWord, pluralize } from '@utils';
import { ValidateReferenceCouponResponse } from '@queries/referenceCoupon/queries';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { MIN_AMOUNT_FOR_DISCOUNT_CREDITS } from '@config/constants';

interface ReferralBannerDiscountProps {
  referenceCouponValidation: ValidateReferenceCouponResponse['validateReferenceCoupon'];
  isBannerVisible: boolean;
  setIsBannerVisible: (isVisible: boolean) => void;
}
const currFormat = new CurrencyFormatter({
  fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
});
export function ReferralBannerDiscount(props: ReferralBannerDiscountProps) {
  const {
    name,
    lastName = '',
    code,
    amount,
    type,
    deliveryPeriods,
    deliveryQuantity,
  } = props?.referenceCouponValidation ?? {};
  const { isBannerVisible } = props;

  if (!isBannerVisible) return null;

  if (type === 'DELIVERY_COUPON' && deliveryPeriods === 1) {
    return (
      <RootDiv>
        <IconContainer>
          <LoyaltyDiscountTagStyled />
        </IconContainer>
        <TextContainer>
          <GiftAmountTypography>
            Tienes {deliveryQuantity}{' '}
            {pluralize('despacho', deliveryQuantity ?? 0, 's')} gratis, sin
            mínimo de compra
          </GiftAmountTypography>
          <ValidityTypography>Válido para clientes nuevos</ValidityTypography>
        </TextContainer>
      </RootDiv>
    );
  }
  if (type === 'DELIVERY_COUPON' && deliveryPeriods > 1) {
    return (
      <RootDiv>
        <IconContainer>
          <LoyaltyDiscountTagStyled />
        </IconContainer>
        <TextContainer>
          <GiftAmountTypography>
            {deliveryQuantity}{' '}
            {pluralize('despacho', deliveryQuantity ?? 0, 's')} gratis al mes,
            sin mínimo de compra
          </GiftAmountTypography>
          <ValidityTypography>
            Válido para clientes nuevos durante {deliveryPeriods} meses
          </ValidityTypography>
        </TextContainer>
      </RootDiv>
    );
  }

  const message = `¡${capitalizeWord(name ?? code)}${
    lastName ? ` ${lastName.charAt(0).toUpperCase()}.` : ''
  } te regaló ${amount?.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
  })} de descuento!`;
  return (
    <RootDiv>
      <IconContainer>
        <LoyaltyDiscountTagStyled />
      </IconContainer>
      <TextContainer>
        <GiftAmountTypography>{message}</GiftAmountTypography>
        <ValidityTypography>
          Válido para clientes nuevos en compras sobre{' '}
          {currFormat.format(MIN_AMOUNT_FOR_DISCOUNT_CREDITS)}
        </ValidityTypography>
      </TextContainer>
    </RootDiv>
  );
}
